const STORAGE_PREFIX = "autoapp:activeUnit";

const INVALID_PARTS = new Set(["", "undefined", "null"]);

const normalizePart = (value) => {
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  return INVALID_PARTS.has(normalized) ? null : normalized;
};

const storageKey = (uid, app) => {
  const safeUid = normalizePart(uid);
  const safeApp = normalizePart(app);
  return safeUid && safeApp ? `${STORAGE_PREFIX}:${safeUid}:${safeApp}` : null;
};

/**
 * WEB-002/WEB-003: persiste solo el último unit ID elegido, con clave por UID
 * y app. Nunca permisos ni contraseña.
 */
export const getActiveUnitId = (uid, app) => {
  try {
    const key = storageKey(uid, app);
    if (!key) return null;
    const raw = localStorage.getItem(key);
    const normalized = normalizePart(raw);
    if (raw !== null && !normalized) localStorage.removeItem(key);
    return normalized;
  } catch {
    return null;
  }
};

export const setActiveUnitId = (uid, app, unitId) => {
  try {
    const key = storageKey(uid, app);
    if (!key) return false;
    const safeUnitId = normalizePart(unitId);
    if (!safeUnitId) {
      localStorage.removeItem(key);
      return false;
    }
    localStorage.setItem(key, safeUnitId);
    return true;
  } catch (error) {
    console.error("Error persistiendo unidad activa:", error);
    return false;
  }
};

export const clearActiveUnit = (uid, app) => {
  try {
    const key = storageKey(uid, app);
    if (!key) return;
    localStorage.removeItem(key);
  } catch {
    /* Storage puede estar deshabilitado por el navegador. */
  }
};

/**
 * Elimina selecciones antiguas o corruptas del usuario sin recorrer claves de
 * otros usuarios. Se usa al cerrar/revocar el contexto operativo.
 */
export const clearActiveUnitsForUser = (uid) => {
  const safeUid = normalizePart(uid);
  if (!safeUid) return;
  try {
    const prefix = `${STORAGE_PREFIX}:${safeUid}:`;
    const keys = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key?.startsWith(prefix)) keys.push(key);
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* Storage puede estar deshabilitado por el navegador. */
  }
};
